import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Alert } from 'antd';
import './onlineOrderLogin.scss';
const OnlineOrderLogin = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loginFailed, setLoginFailed] = useState(false);
    const navigate = useNavigate();
    
    const handleSubmit = async(e) => {
        e.preventDefault();
        setLoginFailed(false); // 重置登录失败状态
        try {
            console.log(`${process.env.REACT_APP_AUTH_SERVER_URL}/auth/qr-login`);
            // const response = await axios.post(`${process.env.REACT_APP_AUTH_SERVER_URL}/auth/qr-login`, { username:email, password }, { withCredentials: true });
            const response = await axios.post(`${process.env.REACT_APP_SERVER_URL}/QRCustomerlogin`, { username:email, password }, { withCredentials: true });
            
            if (response.status === 200 && response.data.jwt) {
                // 保存 JWT 到 sessionStorage 或 localStorage
                sessionStorage.setItem('jwtToken', response.data.jwt);
                
                navigate('/qr_order/adminOrderList');
               
            } else {
                setLoginFailed(true); // 登录失败，显示警告
            }
        } catch (error) {
            setLoginFailed(true); // 登录失败，显示警告
        }
    };

    //clear session storage
    useEffect(() => {
        sessionStorage.clear();
    }, []);
    

    return (
        <div className="global-container">
            <div className="card login-form">
                <div className="card-body">
               
                    
                    <div className="card-icon">
                        <img src="/img/ipos_logo.png" alt="restaurant" />
                    </div>
                    {/* <h4 className="card-title text-center">QR Order Dashboard</h4> */}
                    <div className="card-text">
                        <form onSubmit={handleSubmit}>
                            <div className="form-group">
                                <label htmlFor="exampleInputEmail1">Email address</label>
                                <input 
                                    type="email" 
                                    className="form-control form-control-sm" 
                                    id="exampleInputEmail1" 
                                    aria-describedby="emailHelp"
                                    value={email}
                                    onChange={e => setEmail(e.target.value)}
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="exampleInputPassword1">Password</label>

                                <input 
                                    type="password" 
                                    className="form-control form-control-sm" 
                                    id="exampleInputPassword1"
                                    value={password}
                                    onChange={e => setPassword(e.target.value)}
                                />
                            </div>
                            {loginFailed && <Alert message="Login failed, please try again." type="error" showIcon />}
                            <button type="submit" className="btn btn-primary btn-block">Log in</button>
                            
                            {/* <div className="sign-up">
                                Don't have an account? <a href="#">Create One</a>
                            </div> */}
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OnlineOrderLogin;
